<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="6"
        offset-md="3"
      >
        <v-card class="mb-3">
          <v-toolbar
            flat
            color="rgba(0, 0, 0, 0)"
          >
            <v-btn
              icon
              to="/contact/StaffEntityOfficial"
            >
              <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-title class="text-h6">
            {{ $chPtObjData('chinSubunitName', currSubInfo) }} ({{ currSubInfo.subunitAbbr }}) {{ $chPtObjData('chinTitleForDisplay', currSubInfo) }}
          </v-card-title>
          <v-card-text>
            <div class="mt-4 text-subtitle-1 black--text">
              {{ currSubInfo.chinStaffName }} {{ currSubInfo.portStaffName }} ({{ currSubInfo.staffNickName }})
              <v-chip
                v-if="currSubInfo.vinculumTypeId == 16"
                color="primary"
                outlined
                small
                class="mr-1"
              >
                {{ $t('substitute.substitute') }}
              </v-chip>
              <v-chip
                v-if="currSubInfo.isRefDateOverlapAbsentDateRange"
                color="red"
                outlined
                dark
                small
                class="mr-1"
              >
                {{ $t('substitute.absence') }}
              </v-chip>
              <v-chip
                v-if="substituteTitle"
                color="deep-orange"
                dark
                outlined
                small
                class="mr-1"
              >
                {{ substituteTitle }}
              </v-chip>
            </div>
            <br>
            {{ $t('substitute.absencePeriod') }}
            <div v-if="Array.isArray(leaves) && leaves.length>0">
              <div
                v-for="(leave, index) in leaves"
                :key="index"
                class="py-3"
              >
                <div class="black--text">
                  {{ cutTime(leave.startDate) }} ~ {{ cutTime(leave.endDate) }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="black--text py-3"
            >
              {{ $t('PublicServant.NoData') }}
            </div>

            <!--
            <div
              v-if="currSubInfo.startDate"
              class="black--text py-3"
            >
              {{ cutTime(currSubInfo.startDate) }} ~ {{ cutTime(currSubInfo.endDate) }}
            </div>
            <div
              v-else
              class="black--text py-3"
            >
              {{ $t('PublicServant.NoData') }}
            </div>
            -->
          </v-card-text>
          <v-divider />
          <br>
          <v-card-text>
            {{ $t('substitute.substituteSituation') }}
            <div v-if="Array.isArray(subs) && subs.length>0">
              <div
                v-for="(sub, index) in subs"
                :key="index"
                class="py-3"
              >
                <div class="black--text">
                  {{ cutTime(sub.subContractStartDate) }} ~ {{ cutTime(sub.subContractEndDate) }}
                </div>
                {{ sub.subStaffChinName }} {{ sub.subStaffPortName }} ({{ sub.subCompanyTel }})<br>
                <a :href="'mailto:' + sub.subEmail">{{ sub.subEmail }}</a>
              </div>
            </div>
            <div
              v-else
              class="black--text py-3"
            >
              {{ $t('PublicServant.NoData') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { substituteModule } from '../../store/moduleName'
import substituteVuex from '../../store/modules/substitute/substitute'
import store from '../../store'
import { mapState } from 'vuex'
import g2eApi from '../../api/hr/g2e'
import { cutTime } from '@/utils/datetimeUtil'
import { mdiArrowLeft } from '@mdi/js'

if (!store.state[substituteModule]) store.registerModule(substituteModule, substituteVuex)

export default {
  components: {
  },
  props: {
    substituteTitle: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      leaves: [],
      subs: [],
      mdiArrowLeft: mdiArrowLeft
    }
  },
  computed: {
    ...mapState({
      currSubInfo: state => state[substituteModule].currSubInfo,
      selectedDate: state => state[substituteModule].selectedDate
    })
  },
  watch: {
  },
  created () {
    if (!this.currSubInfo) {
      this.$router.push('/contact/StaffEntityOfficial')
    }
    g2eApi.findStaffLeaveInfo(this.selectedDate, this.currSubInfo.staffCode, this.currSubInfo.subunitEntityId, resp => {
      if (resp.status === 201 || resp.status === 200) {
        this.leaves = resp.data
      }
    })
    g2eApi.findStaffSubsInfo(this.selectedDate, this.currSubInfo.staffCode, this.currSubInfo.subunitEntityId, resp => {
      if (resp.status === 201 || resp.status === 200) {
        this.subs = resp.data
      }
    })
  },
  methods: {
    cutTime: function (date) {
      return cutTime(date)
    }
  }
}
</script>
